
import { Vue } from 'vue-class-component'
import liff from '@line/liff'
import { isDeeplinkFormat, isWebsiteFormat } from '@/helpers/validator'
import { useStore } from '@/store'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'

export default class Banners extends Vue {
  store = useStore()
  hasBeenBlured = false
  blurCounting = 0
  hideBanner = false

  created() {
    this.handleBannerClickEvent()
  }

  handleBannerClickEvent() {
    window.onblur = () => {
      this.hasBeenBlured = true
      this.blurCounting++
    }
    window.onfocus = () => {
      if (this.hasBeenBlured) {
        this.closeLoadingLabel()
        this.hasBeenBlured = false
      }
    }
  }

  openCoinExchange() {
    this.openUrl(process.env.VUE_APP_COIN_TRANSFER_URL!)

    this.updateGAEvent('โอนคอยน์')
  }

  updateGAEvent(topicSection: string) {
    addGAEvent({
      event: 'view_banner',
      component: 'banner',
      topic_section: topicSection, 
      banner_id: '',
      banner_name: ''
    })
    addGAEvent({
      event: 'select_banner',
      component: 'banner',
      topic_section: topicSection, 
      banner_id: '',
      banner_name: ''
    })
  }

  showLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', true)
    this.store.commit('app/setLoadingBarLabelHtml', 'กำลังเปิด<br/>โลตัส สมาร์ท แอพ')
  }

  closeLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', false)
    this.store.commit('app/setLoadingBarLabelHtml', '')
  }

  openOneApp(url: string) {
    const query = this.$route?.query

    if(query['is_disabled_deeplink'] !== 'true') {
      liff.openWindow({ url})
    }
  }

  openAppStore() {
    const query = this.$route?.query

    if(query['is_disabled_deeplink'] !== 'true') {
      liff.openWindow({
        url: process.env.VUE_APP_DOWNLOAD_LOTUSS!
      })
    }
  }

  openUrl(bannerUrl: string) {
    if (bannerUrl) {
      if (isDeeplinkFormat(bannerUrl)) {
        this.showLoadingLabel()
        const previousBlur = this.blurCounting
        this.openOneApp(bannerUrl)
        setTimeout(() => {
          /*
          the app on blur state is not updated,
          we will assume the app does not open one app
          so that we will force use to open app store instead
          */
          if (previousBlur === this.blurCounting) {
            this.openAppStore()
            this.closeLoadingLabel()
          }
        }, 2000)
      } else if (isWebsiteFormat(bannerUrl)) {
        this.openOneApp(bannerUrl)
      }
    }
  }

  getImage() {
    return `${process.env.VUE_APP_S3_IMAGE_URL}/coin-exchange-banner.png`
  }

  errorImage(event: any) {
    event.target.onerror = null
    event.target.src = require('../../assets/img/no-image-placeholder-carausol.png')
    this.hideBanner = true
  }
}
